import React from 'react';
import { MapPin, Navigation } from 'lucide-react';

const RouteMap = ({ rally }) => {
  // Generate Google Maps embed URL from route (no API key required)
  const getMapUrl = () => {
    if (!rally?.route) return null;
    
    // Parse common route formats like "Houston → Austin" or "Houston to Austin"
    const routeParts = rally.route.split(/→|to|>|,/i).map(p => p.trim()).filter(Boolean);
    
    if (routeParts.length < 2) {
      // Single location - just show it on the map
      if (routeParts.length === 1) {
        const q = encodeURIComponent(routeParts[0] + ', Texas');
        return `https://maps.google.com/maps?q=${q}&output=embed`;
      }
      return null;
    }
    
    const origin = encodeURIComponent(routeParts[0] + ', Texas');
    const destination = encodeURIComponent(routeParts[routeParts.length - 1] + ', Texas');
    // Use legacy embed which doesn't require an API key
    return `https://maps.google.com/maps?saddr=${origin}&daddr=${destination}&output=embed`;
  };

  const mapUrl = getMapUrl();

  if (!mapUrl) {
    return (
      <div className="bg-[#1C1C1C] border border-[#2A2A2A] p-8 text-center">
        <MapPin className="w-12 h-12 text-[#2A2A2A] mx-auto mb-4" />
        <p className="text-[#A19D98]">Route map coming soon</p>
        {rally?.route && (
          <p className="text-[#F2EDE6] mt-2 font-['Oswald']">{rally.route}</p>
        )}
      </div>
    );
  }

  return (
    <div data-testid="route-map" className="space-y-4">
      <div className="flex items-center gap-2 text-[#E8651A]">
        <Navigation size={18} />
        <span className="font-['Oswald'] tracking-wider">ROUTE MAP</span>
      </div>
      
      <div className="relative aspect-video bg-[#1C1C1C] border border-[#2A2A2A] overflow-hidden">
        <iframe
          src={mapUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={`Route map for ${rally?.name || 'Rally'}`}
        />
      </div>

      {rally?.route && (
        <p className="text-[#A19D98] text-sm flex items-center gap-2">
          <MapPin size={14} />
          {rally.route}
        </p>
      )}

      <a
        href={`https://www.google.com/maps/dir/${rally.route?.replace(/→|>/g, '/').replace(/\s+/g, '+')}`}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-secondary inline-flex items-center gap-2 text-sm"
      >
        <Navigation size={14} />
        Open in Google Maps
      </a>
    </div>
  );
};

export default RouteMap;
